// extracted by mini-css-extract-plugin
export default {"taskChange":"taskChange--VQdxt","markerAnimationScale":"markerAnimationScale--TFgEy"};